module.exports = __webpack_public_path__ + "static/media/not-available.97ad7333.png";